'use strict';exports.__esModule = true;exports.consultationReset = exports.sendConsultationForm = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var

promise = _reduxLoop.Effects.promise;

var COMPANY_CONTACT_US_URL = 'messaging/contact-agency-personal';
var COMPANY_COMMUNITY_CONTACT_US_URL = 'messaging/contact-agency-personal-community-member';

var sendConsultationForm = (0, _reduxAct.createAction)('/SEND_CONSULTATION');
var sendConsultationSuccess = (0, _reduxAct.createAction)('/SEND_CONSULTATION_SUCCESS');
var sendConsultationFail = (0, _reduxAct.createAction)('/SEND_CONSULTATION_FAIL');
var consultationReset = (0, _reduxAct.createAction)('/CONSULTATION_RESET');

var initialState = {
  formError: null,
  formSubmitting: false,
  formSubmitted: false };


var submitConsultationForm = function submitConsultationForm(_ref) {var is_community_member = _ref.is_community_member,data = _objectWithoutProperties(_ref, ['is_community_member']);return _axios2.default.
  post(is_community_member ? COMPANY_COMMUNITY_CONTACT_US_URL : COMPANY_CONTACT_US_URL, data).
  then(sendConsultationSuccess).
  catch(sendConsultationFail);};

var handleConsultationForm = function handleConsultationForm(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    formSubmitting: true,
    formSubmitted: false }),
  promise(submitConsultationForm, action));};

var handleConsultationSuccess = function handleConsultationSuccess(state) {return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: null });};


var handleConsultationFormFail = function handleConsultationFormFail(state, _ref2) {var response = _ref2.response;return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: response.data });};


var handleConsultationReset = function handleConsultationReset() {return Object.assign({}, initialState);};

var consultation = (0, _reduxAct.createReducer)(function (on) {
  on(sendConsultationForm, handleConsultationForm);
  on(sendConsultationSuccess, handleConsultationSuccess);
  on(sendConsultationFail, handleConsultationFormFail);
  on(consultationReset, handleConsultationReset);
}, initialState);exports.


sendConsultationForm = sendConsultationForm;exports.
consultationReset = consultationReset;exports.default =


consultation;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/consultation.js
// module id = 1270
// module chunks = 0